import { render, staticRenderFns } from "./GotoStep.vue?vue&type=template&id=08678ba0&scoped=true"
import script from "./GotoStep.vue?vue&type=script&lang=js"
export * from "./GotoStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08678ba0",
  null
  
)

export default component.exports